module.exports = __webpack_public_path__ + "img/Angela_Myers.5fb00c6d.png";